module.exports = __webpack_public_path__ + "media/images/aboutus/cover-c23829a14a66c5871aa4ee0c1d96c29a.png";